import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';

import { formatTextNumberInputValue } from '@commons/utils/format';
import InputContentModal from '@commons/Modals/InputContentModal';

import { BulletList, Container } from './styledComponents';

const CatalogPriceModalContent = (props) => {
  const { price, onChangePrice } = props;

  const handleChange = (value) => {
    const formattedValue = formatTextNumberInputValue(value, null);

    if (formattedValue !== null && formattedValue < 0) {
      return;
    }

    onChangePrice(formattedValue);
  };

  return (
    <Container>
      <BulletList>
        <li>{i18next.t('EXTERNAL_CLIENTS.CATALOG.PRICE_MODAL_BULLET_SCOPE')}</li>
        <li>{i18next.t('EXTERNAL_CLIENTS.CATALOG.PRICE_MODAL_BULLET_ORDERS')}</li>
      </BulletList>
      <InputContentModal
        label={`*${i18next.t('EXTERNAL_CLIENTS.CATALOG.PRICE_MODAL_NEW_PRICE_LABEL')}`}
        type={'text'}
        value={price === null ? '' : price}
        autoFocus
        onChange={handleChange}
      />
    </Container>
  );
};

CatalogPriceModalContent.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChangePrice: PropTypes.func.isRequired,
};

CatalogPriceModalContent.defaultProps = {
  price: null,
};

export default CatalogPriceModalContent;
